import {observer} from 'mobx-react';
import {useEffect, useState} from 'react';
import styled from 'styled-components';
import {KeywordSelector} from './KeywordSelector';
import {HeadingsTree} from './HeadingsTree';
import {useStore} from '@/store/root-store';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars, faBarsSort} from '@fortawesome/pro-solid-svg-icons';
import {Tooltip} from 'antd';
import {toJS} from 'mobx';
import {faArrowUpRightFromSquare, faListTree} from '@fortawesome/pro-regular-svg-icons';
import {generateHeadingOutline} from '@/utils/blockRenderComponents';
import {NextImg} from '@/utils/nextImg';

interface Props {
  setCompListCollapsed: (value: boolean) => void;
  compListCollapsed: boolean;
  htmlToDraft: any;
  activeKw: string;
  setActiveKw: (value) => void;
  setShowBulkAddContentBtn?: (value: boolean) => void;
  showBulkAddContentBtn?: boolean;
  setCheckedCount?: (value: number) => void;
  checkedCount?: number;
  setCheckedHeadingsWithTags?: (value: string) => void;
  checkedHeadingsWithTags?: string;
  setCheckedIndexData?: (value: any) => void;
  checkedIndexData?: any;
}

export const CompetitorHeadingsDrawerContent = observer(({
  htmlToDraft,
  setCompListCollapsed,
  compListCollapsed,
  activeKw,
  setActiveKw,
  setCheckedIndexData,
  checkedIndexData,
  setShowBulkAddContentBtn,
  showBulkAddContentBtn,
  setCheckedCount,
  checkedCount,
  setCheckedHeadingsWithTags,
  checkedHeadingsWithTags}: Props) => {
  const {contentOptimizer: {currentPage}} = useStore('');
  const {settings: {customer: {profile: {isSubscriber}}}} = useStore('');

  const [competitors, setCompetitors] = useState(currentPage.analytics?.competitorsData?.find(item => item.keyword == activeKw)?.competitors ?? []);
  const [activeCompetitor, setActiveCompetitor] = useState(currentPage.analytics?.competitorsData?.find(item => item.keyword == activeKw)?.competitors?.filter(competitor => competitor?.headingsHierarchy && competitor?.headingsHierarchy?.length)[0] ?? null);


  useEffect(() => {
    if (currentPage?.topRankingCompetitorActiveKw && currentPage?.analytics?.competitorsData?.length && currentPage?.analytics?.competitorsData.find(item => item.keyword == currentPage?.topRankingCompetitorActiveKw)) {
      !activeKw && setActiveKw(currentPage?.topRankingCompetitorActiveKw);
    } else if (currentPage?.analytics?.competitorsData && currentPage?.analytics?.competitorsData[0]) {
      !activeKw && setActiveKw(currentPage?.analytics?.competitorsData[0]?.keyword);
    } else {
      setActiveKw('');
    }
  }, [...(currentPage?.analytics?.competitorsData ?? ''), currentPage?.analytics?.competitorsData?.length]);

  useEffect(() => {
    if (toJS(currentPage).analytics?.competitorsData) {
      const contentState = currentPage.currentEditorState.getCurrentContent();
      const outline = generateHeadingOutline(contentState);
      const currentArticleOutline = [{
        title: 'Current Article Outline',
        headingsHierarchy: outline,
        isCurrentArticleOutline: true,
      }];

      const updatedCompetitors = toJS(currentPage).analytics.competitorsData?.map(value => {
        return {
          ...value,
          competitors: [...currentArticleOutline, ...value.competitors],
        };
      });
      setCompetitors(updatedCompetitors?.find(item => item.keyword == activeKw)?.competitors ?? []);
      if (!activeCompetitor) {
        setActiveCompetitor(toJS(currentPage.analytics?.competitorsData)?.find(item => item.keyword == activeKw)?.competitors?.filter(competitor => competitor?.headingsHierarchy && competitor?.headingsHierarchy?.length)[0] ?? null);
      }
    }
  }, [currentPage.analytics?.competitorsData, activeKw, currentPage.currentEditorState]);

  const competitorsChangeHandler = (competitorsList: any[]) => {
    setCompetitors(competitorsList);

    setActiveCompetitor(competitorsList[0]);
  };

  // const addDefaultSrc = e => {
  //   e.target.src = '/img/world-wide-web.svg';
  // };

  return <Wrapper>
    <Left isCollapsed={compListCollapsed}>
      <Header>
        <FontAwesomeIcon icon={compListCollapsed ? faBars : faBarsSort} onClick={() => setCompListCollapsed(!compListCollapsed)} fontSize={20} style={{marginTop: 20, marginRight: 10, cursor: 'pointer'}}/>
        <KeywordSelector compListCollapsed={compListCollapsed} store={toJS(currentPage)} isSubscriber={isSubscriber} setCompetitors={competitorsChangeHandler} setActiveKw={setActiveKw} activeKw={activeKw}/>
      </Header>
      <CompetitorsList>
        {competitors?.length? competitors?.filter(competitor => competitor?.headingsHierarchy && competitor?.headingsHierarchy?.length)?.map((competitor, idx) => {
          return <>
            {competitor?.isCurrentArticleOutline ?
              <CurrentArticleOutline onClick={() => setActiveCompetitor(competitor)} isActive={activeCompetitor?.title == competitor?.title}>
                <FontAwesomeIcon icon={faListTree} />
                <div className='text'>Current Article Outline</div>
              </CurrentArticleOutline>:
              <SingleCompetitor key={idx} onClick={() => setActiveCompetitor(competitor)} isActive={activeCompetitor?.title == competitor?.title}>
                <Order className='competitorOrder'> {competitors?.filter(value => value?.headingsHierarchy && value?.headingsHierarchy?.length && value?.isCurrentArticleOutline)?.length ? idx : idx + 1}  </Order>
                <NameLogoUrl>
                  <Tooltip
                    overlayInnerStyle={{backgroundColor: '#121212', borderRadius: 5}}
                    title={compListCollapsed ? <div>
                      <Name className='compettiorName' style={{color: '#fff'}}>{competitor.title}</Name>
                      <Url className='compettiorUrl' href={competitor.url} target='_blank'>
                        {competitor.url}
                      </Url>
                    </div> : null}>
                    <Logo>
                      <NextImg
                      // onError={e => addDefaultSrc(e)}
                        src={`https://www.google.com/s2/favicons?sz=16&domain_url=${competitor?.url}`} style={{width: 20, height: 20}}/>
                    </Logo>
                  </Tooltip>
                  {!compListCollapsed && <NameAndUrl>
                    <Name className='compettiorName'>{competitor.title}</Name>
                    <Url className='compettiorUrl'>
                      <span style={{
                        display: 'inline-block',
                        maxWidth: 180,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}>{competitor.url}</span>
                      <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{marginLeft: 10}} onClick={() => window.open(competitor?.url, '_blank')}/>
                    </Url>
                  </NameAndUrl>}
                </NameLogoUrl>
              </SingleCompetitor>
            }</>;
        }) : <Headingoutlines>Add atleast one target keyword to view the Heading outlines</Headingoutlines>
        }

      </CompetitorsList>
    </Left>
    <Right>
      <HeadingsTree
        activeCompetitor={activeCompetitor}
        htmlToDraft={htmlToDraft}
        setCheckedIndexData={setCheckedIndexData}
        checkedIndexData={checkedIndexData}
        setCheckedHeadingsWithTags={setCheckedHeadingsWithTags}
        checkedHeadingsWithTags={checkedHeadingsWithTags}
        setShowBulkAddContentBtn={setShowBulkAddContentBtn}
        showBulkAddContentBtn={showBulkAddContentBtn}
        setCheckedCount={setCheckedCount}
        checkedCount={checkedCount}
      />
    </Right>


  </Wrapper>;
});

const Wrapper = styled.div`
  padding: 10px 30px 30px;
  display: flex;
  cursor: default;
`;

const Header = styled.div`
  display: flex;
  margin-bottom: 20px;
  align-items: center;
`;

const Left = styled.div<{isCollapsed: boolean}>`
  width: ${p => p.isCollapsed ? '105px' : 'auto'};
  background: transparent;
  padding-right: 30px;
`;
const Right = styled.div`
  background-color: #fff;
  width: 100%;
  border: 1px solid #E8E8E8;
  box-shadow: 1px -2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 14px;
  padding: 20px 30px;
`;
const CompetitorsList = styled.div`

`;
const SingleCompetitor = styled.div<{isActive?: boolean}>`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 7px;
  padding: 9px;
  background-color: ${p => p.isActive ? '#233A61' : 'transparent'};
  border-radius: 8px;
  transition: background .3s ease;

  .compettiorName, .competitorOrder, .compettiorUrl {
    ${p => p.isActive && 'color: #fff;'}
  }

  :hover {
    background-color: #233A61;

    .compettiorName, .competitorOrder, .compettiorUrl {
      color: #fff;
    }
  }
`;
const Order = styled.div`
  color: #121212;
  width: 25px;
`;
const NameLogoUrl = styled.div`
  display: flex;
  align-items: center;
`;
const Logo = styled.div`
  margin-right: 10px;
`;
const NameAndUrl = styled.div`
  text-align: left;
  max-width: 200px;
`;
const Name = styled.div`
  color: #121212;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
const Url = styled.a`
  color: #2D6CCA;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  font-size: 12px;
  align-items: center;
`;

const Headingoutlines = styled.p`
  color: red;
  margin-left: 30px;
  margin-top: -9px;
`;

const CurrentArticleOutline = styled.div<{isActive?: boolean}>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 32px;
  margin-bottom: 10px;
  cursor: pointer;
  border-radius: 8px;
  ${p => p.isActive && 'color: #fff;'}
  svg {
    width: 16px;
    height: 13px;
  }
  .text {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
    color: rgba(18, 18, 18, 1);
    ${p => p.isActive && 'color: #fff;'}
    text-decoration: underline;
    padding: 7px;
  }
  background-color: ${p => p.isActive ? '#233A61' : 'transparent'};
  :hover {
    background-color: #233A61;
    color: #fff;

    .text {
      color: #fff;
    }
  }
`;
